import { reactive, toRefs, watch } from "vue";

const listings = new Map();

// La persistencia entre visitas se activa únicamente para los listados que la solicitan.
export function useListingState(key, defaults, { persist = false } = {}) {
  const storageKey = `web-bochas:listing:${key}`;
  if (!listings.has(key)) {
    const initial = { ...defaults };
    if (persist && typeof window !== "undefined") {
      try {
        const saved = JSON.parse(window.localStorage.getItem(storageKey) || "null");
        for (const field of Object.keys(defaults)) {
          if (saved && typeof saved[field] === typeof defaults[field]) initial[field] = saved[field];
        }
      } catch {
        // Si el almacenamiento no está disponible, se conserva el estado durante la visita.
      }
    }
    listings.set(key, reactive(initial));
  }
  const state = listings.get(key);
  if (persist && typeof window !== "undefined") {
    watch(state, (value) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(value));
      } catch {
        // El filtro sigue funcionando aunque el navegador no permita guardarlo.
      }
    }, { deep: true, flush: "sync" });
  }
  return toRefs(state);
}
